import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
  ANNOUNCEMENT_SERVICE,
  AnnouncementService
} from '@/app/platform/platform-data/services/types';
import { createEntitiesComponentConfigWithoutPagination } from '@shared/components/lists/e-entity-list/e-entity-list.component';
import { Announcement } from '@/app/platform/platform-data/models/announcement';
import { DataTableHeader } from '@shared/tables/components/e-simple-data-table/e-simple-data-table.component';

@Component({
    selector: 'p-announcement-management-view',
    templateUrl: './p-announcement-management-view.component.html',
    styleUrls: ['./p-announcement-management-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PAnnouncementManagementViewComponent {
  constructor(
    @Inject(ANNOUNCEMENT_SERVICE)
    private readonly service: AnnouncementService
  ) {}

  readonly config = createEntitiesComponentConfigWithoutPagination(this.service, async () =>
    Announcement.createDefault()
  );
  readonly headers: DataTableHeader<Announcement>[] = [
    {
      key: 'key',
      label: 'Key'
    },
    {
      key: 'title',
      label: 'Titel'
    },
    {
      key: 'message',
      label: 'Boodschap'
    },
    {
      key: 'level',
      label: 'Level'
    },
    {
      key: 'show',
      label: 'Toon',
      width: 250
    }
  ];
}
